import { render, staticRenderFns } from "./BaseDefinitionList.vue?vue&type=template&id=35b75148&lang=pug&"
import script from "./BaseDefinitionList.vue?vue&type=script&lang=js&"
export * from "./BaseDefinitionList.vue?vue&type=script&lang=js&"
import style0 from "./BaseDefinitionList.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
